import { z } from 'zod'

const Operation = z.object({ action: z.string(), result: z.string() })

/** How a traced execution ended. `interrupted`: the run stopped it (`isRunAbort`), so it says nothing about the app. */
export const ExecutionOutcome = z.enum(['completed', 'failed', 'interrupted'])
export type ExecutionOutcome = z.infer<typeof ExecutionOutcome>

/** `journey.execute-result` data: `result` describes a returned execution, `error` why it failed or stopped. */
export const ExecuteResultData = z.object({
  outcome: ExecutionOutcome, result: z.string().optional(), error: z.string().optional(), operations: z.array(Operation).default([]),
})
export type ExecuteResultData = z.infer<typeof ExecuteResultData>

// Records written before `outcome` existed never marked a run stop.
const RecordedExecuteResult = ExecuteResultData.extend({ outcome: ExecutionOutcome.optional() })

/** Parses a recorded `journey.execute-result` with its action's `error`. */
export function parseExecuteResult(data: unknown, error: string | null): ExecuteResultData {
  const recorded = RecordedExecuteResult.parse(data)
  return { ...recorded, outcome: recorded.outcome ?? (recorded.error || error ? 'failed' : 'completed') }
}
